import { Text, Box, Card, Flex, Badge } from '@chakra-ui/react';
import { TClusterPayload } from 'pages/ClusterManagement/types';

const ClusterCard = ({
    cluster,
    isNew,
    selected,
}: {
    cluster?: TClusterPayload;
    isNew?: boolean;
    selected?: boolean;
}) => {
    return !cluster ? null : (
        <Card p={2} transition="height .3s" borderColor={selected ? 'blue.500' : 'white'} borderWidth={1}>
            <Flex pb={2} alignItems="center" gap={3}>
                <Text>{cluster.label}</Text>
                <Box flexGrow={1} />
                {isNew && (
                    <Badge bgGradient="linear(to-r, blue.500, blue.300)" color="white">
                        NEW
                    </Badge>
                )}
                <Box
                    w="20px"
                    h="20px"
                    borderRadius="50%"
                    bg={cluster.color}
                    border={cluster.color === '#ffffff' ? '1px solid #E2E8F0' : 'none'}
                    mr="4px"
                    display="inline-block"
                />
            </Flex>
        </Card>
    );
};

export default ClusterCard;
